// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_1g4q3","title":"_3AgOd"};